<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-tabs>
                <b-tab title="Basisgegevens" active>
                  <b-row>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Omschriving">
                            <b-form-input type="text" required v-model="item.description" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="E-mail">
                            <b-form-input type="text" v-model="item.email" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Telefoon">
                            <b-form-input type="text" v-model="item.phone" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Hoofdcontactpersoon">
                            <b-form-checkbox id="checkbox-1" v-model="item.is_main_contact" :disabled="!editable" name="is_main_contact" value="1" unchecked-value="0">
                              Dit contactpersoon moet in de kolom voor algemene vragen weergegeven worden
                            </b-form-checkbox>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <hr>
                          <div v-if="editable">
                          <b-button @click.prevent="cancelEdit" class="mr-3" variant="warning">Annuleren</b-button>
                            <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                          </div>
                          <div v-if="!editable">
                          <b-button type="button" @click.prevent="editable = true" variant="primary" class="pull-right">Bewerken</b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { updateData, getData } from '../../api';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: 'contact',

  data() {
    return {
      saveButtonDisabled: false,
      editable: false,
      item: {},
    };
  },

  methods: {
    async refresh() {
      await this.getItem();
    },

    async getItem() {
      this.item = await getData('contacts/' + this.$route.params.id).then(
        (response) => response.data.data
      );
    },

    async saveItem() {
      this.saveButtonDisabled = true;

      let formData = new FormData();
      Object.keys(this.item).forEach(key => {
        formData.append(key, this.item[key]);
      });

      const request = await updateData('contacts/' + this.$route.params.id, formData);

      if (request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
  },

  computed: {
    userRole: function() {
      return this.$store.state.userRole;
    },
  },
  beforeMount() {
    this.getItem();
  },
};
</script>

